module.exports = __webpack_public_path__ + "img/dip-logo-home.12cde645.png";